// extracted by mini-css-extract-plugin
export default {"button":"InvitePlayers_button__IiQ4t","scrollable":"InvitePlayers_scrollable__WY1ls","pairPhoto":"InvitePlayers_pairPhoto__TjHp2"};